// components/exercise/NoExercisePlan.jsx
import React from "react";
import { useTranslation } from "react-i18next";
import NotFound from "@components/ui/NotFound";

const NoExercisePlan = ({ 
  exerciseCheck, 
  generatePlanLoading, 
  subscription, 
  handleClickOpen, 
  navigate 
}) => {
  const { t } = useTranslation();

  if (exerciseCheck || generatePlanLoading) return null;

  return (
    <div className="bg-white rounded-[12px] p-[24px]">
      <NotFound />
      <p className="text-center">
        {t("exercisePlan.haveNoPlan")}
        <br /> {t("exercisePlan.clickOn")}{" "}
        <span
          className="text-blue-600 cursor-pointer"
          onClick={() =>
            subscription?.status === "active" ||
            subscription?.status === "pending-cancel"
              ? handleClickOpen()
              : navigate("/renew-subscription")
          }
        >
          {t("exercisePlan.generatePlan")}
        </span>{" "}
        {t("exercisePlan.toCreatePlan")}
      </p>
    </div>
  );
};

export default NoExercisePlan;